/**
 * Professional color palette utilities for Lane Operating Hours
 */

// Checkpoint colors (cycle through 6 professional colors)
const CHECKPOINT_COLORS = [
  {
    bg: 'bg-blue-900/10',
    border: 'border-blue-500',
    name: 'Steel Blue'
  },
  {
    bg: 'bg-teal-900/10',
    border: 'border-teal-500',
    name: 'Teal'
  },
  {
    bg: 'bg-slate-800/30',
    border: 'border-slate-500',
    name: 'Slate'
  },
  {
    bg: 'bg-indigo-900/10',
    border: 'border-indigo-500',
    name: 'Indigo'
  },
  {
    bg: 'bg-emerald-900/10',
    border: 'border-emerald-500',
    name: 'Emerald'
  },
  {
    bg: 'bg-sky-900/10',
    border: 'border-sky-500',
    name: 'Sky'
  }
];

// Lane type colors (fixed mapping)
const LANE_TYPE_COLORS: Record<string, { bg: string; border: string; text: string }> = {
  'Priority': {
    bg: 'bg-blue-600/20',
    border: 'border-blue-500/50',
    text: 'text-blue-300'
  },
  'Standard': {
    bg: 'bg-emerald-600/20',
    border: 'border-emerald-500/50',
    text: 'text-emerald-300'
  },
  'TSA PreCheck': {
    bg: 'bg-indigo-600/20',
    border: 'border-indigo-500/50',
    text: 'text-indigo-300'
  },
  'CLEAR': {
    bg: 'bg-teal-600/20',
    border: 'border-teal-500/50',
    text: 'text-teal-300'
  }
};

// Default color for unknown lane types
const DEFAULT_LANE_TYPE_COLOR = {
  bg: 'bg-gray-600/20',
  border: 'border-gray-500/50',
  text: 'text-gray-300'
};

/**
 * Get checkpoint color by index (cycles through colors)
 */
export const getCheckpointColor = (index: number) => {
  return CHECKPOINT_COLORS[index % CHECKPOINT_COLORS.length];
};

/**
 * Get lane type color by type name
 */
export const getLaneTypeColor = (typeName: string) => {
  return LANE_TYPE_COLORS[typeName] || DEFAULT_LANE_TYPE_COLOR;
};
